import { useNavigate } from "react-router-dom";

export interface UserBadgeProps {
    profileId: number;
    profileIconUrl: string;
    size?: "small"
}

export const UserBadge: React.FC<UserBadgeProps> = (props) => {
    const navigate = useNavigate();

    const handleProfileClick = () => {
        navigate('/profile/' + props.profileId);
    }

    return (
        <div className={`${props.size === "small" ? "w-12 h-12" : "w-16 h-16"} cursor-pointer`} onClick={() => handleProfileClick()}>
            <img className="w-full h-full object-cover rounded-full" src={props.profileIconUrl}/>
        </div>
    )
}